module.exports = __webpack_public_path__ + "img/images-02.d26f9585.png";